import { render, staticRenderFns } from "./AccountRegisterSearch.vue?vue&type=template&id=a4c30d5c"
import script from "./AccountRegisterSearch.vue?vue&type=script&lang=js"
export * from "./AccountRegisterSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports